import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import Hero from '../../sections/Hero';
import QuoteRequestForm from '../../sections/QuoteRequestForm';

const SpecialtyServicesPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Specialty Services</title>
        <meta
          name="description"
          content="Specialized delivery and transportation services in Northeast Wisconsin. Custom solutions for unique needs."
        />
      </Helmet>

      <Hero 
        title="Specialty Services"
        subtitle="Custom solutions for your unique delivery and transportation needs in Northeast Wisconsin."
        backgroundImage="/assets/images/specialty-services-bg.jpg"
        showQuickForm={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h2" gutterBottom>
            Our Specialty Services
          </Typography>
          <Typography variant="body1" paragraph>
            At JBR Delivery LLC, we understand that some delivery and transportation needs fall outside of standard service categories. That's why we offer specialty services designed to accommodate unique requirements.
          </Typography>
          <Typography variant="body1" paragraph>
            Our specialty services include furniture assembly, estate cleanouts, storage unit transportation, auction pickups, and more. If you have a specialized need, contact us to discuss how we can create a custom solution for you.
          </Typography>
        </Container>
      </Box>

      <QuoteRequestForm />
    </>
  );
};

export default SpecialtyServicesPage;
